export const primary = '#22c26e';
export const secondary = '#ce1212';
export const error = '#ffbb44';
export const black = '#000000';
export const white = '#ffffff';
export const deepPurple = '#6441a4';
export const grey = '#f5f6fa';
export const grey_dark = '#ececf3';
export const text__primary = '#233a54';
export const text__primary_dark = '#1a2b3e';
export const text__secondary = '#0000008a';
export const gray = 'rgba(0, 0, 0, 0.54)';



// WEBPACK FOOTER //
// ./src/style/color.js